export const PCI_REQUIREMENTS = [
  "Install and maintain network security controls",
  "Apply secure configurations to all system components",
  "Protect stored account data",
  "Protect cardholder data with strong cryptography",
  "Protect all systems against malware",
  "Develop and maintain secure systems and software",
  "Restrict access to cardholder data by business need",
  "Identify users and authenticate access",
  "Restrict physical access to cardholder data",
  "Log and monitor all access to cardholder data",
  "Test security of systems and networks regularly",
  "Support information security with organizational policies",
];

export const PCI_DSS_CATALOG = [
  {
    requirement: "1",
    subRequirement: "1.2",
    description: "Network security controls are configured and maintained.",
    testingProcedure: "Review configurations; inspect change history; sample rule reviews.",
    implementationGuidance: "Use NGFW + segmentation; ensure rule recertification.",
    evidence: "Firewall configs, rule review reports",
    rbiMapping: "RBI-NET-02",
    compensatingControl: "Network microsegmentation with monitoring",
  },
  {
    requirement: "3",
    subRequirement: "3.5",
    description: "Cryptographic keys are protected and managed.",
    testingProcedure: "Review key mgmt procedures; inspect HSM/KMS settings.",
    implementationGuidance: "Centralize key management; rotate keys.",
    evidence: "Key mgmt SOP, HSM evidence",
    rbiMapping: "RBI-DAT-04",
    compensatingControl: "Dual control + audit logging",
  },
  {
    requirement: "10",
    subRequirement: "10.2",
    description: "Audit logs are implemented to link access to individuals.",
    testingProcedure: "Sample logs; verify completeness and retention.",
    implementationGuidance: "Central SIEM; ensure integrity + retention.",
    evidence: "SIEM dashboards, retention proof",
    rbiMapping: "RBI-SOC-04",
    compensatingControl: "Central syslog + immutable archive",
  },
];
